export default __webpack_public_path__ + "static/profile-5089ef42759b3999ea0ed25432460932.jpg";